import { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Volume2, Loader2, Square } from "lucide-react";
import { api } from "../lib/api";

const PATH_KEY = {
  "/tableau": "dashboard", "/punch-mobile": "punch", "/employes": "employees",
  "/feuilles": "timesheets", "/approbations": "approvals", "/chantiers": "chantiers",
  "/projets": "projects", "/codes-cout": "costCodes", "/export-paie": "exportPayroll",
  "/rapports": "reports", "/securite": "security", "/loi25": "loi25",
  "/conformite-ccq": "ccq", "/sauvegardes": "backups", "/integrations": "integrations",
  "/parametres": "settings", "/entreprises": "companies", "/abonnement": "subscription",
  "/console": "console", "/maintenance": "maintenance",
};

function resolveKey(pathname) {
  if (PATH_KEY[pathname]) return PATH_KEY[pathname];
  const match = Object.keys(PATH_KEY).sort((a, b) => b.length - a.length).find((p) => pathname.startsWith(p));
  return match ? PATH_KEY[match] : "default";
}

export function VoiceGuideButton() {
  const { t } = useTranslation();
  const loc = useLocation();
  const [speaking, setSpeaking] = useState(false);
  const audioRef = useRef(null);

  const stop = () => {
    if (audioRef.current) { audioRef.current.pause(); try { URL.revokeObjectURL(audioRef.current.src); } catch { /* noop */ } audioRef.current = null; }
    setSpeaking(false);
  };

  const toggle = async () => {
    if (speaking) { stop(); return; }
    const key = resolveKey(loc.pathname);
    const text = t(`guide.${key}`, { defaultValue: t("guide.default") });
    try {
      setSpeaking(true);
      const blob = await api.tts(text);
      const a = new Audio(URL.createObjectURL(blob));
      audioRef.current = a;
      a.onended = stop; a.onerror = stop;
      await a.play();
    } catch { setSpeaking(false); }
  };

  return (
    <button className="top-btn" onClick={toggle} data-testid="page-voice-guide-btn"
      title={t("guide.listen")} style={speaking ? { color: "var(--gold)", borderColor: "var(--border-gold)" } : undefined}>
      {speaking ? <Square size={16} fill="currentColor" /> : <Volume2 size={18} />}
    </button>
  );
}
